import React from "react";

/**
 * Shared page header — full-bleed, clears fixed navbar.
 */
const Banner = ({ title, subtitle }) => {
  return (
    <div className="w-full overflow-hidden">
      {/* Same color as navbar so no white strip under the menu */}
      <div className="w-full bg-[#258695] pt-[88px] sm:pt-[92px] md:pt-[96px]">
        <div className="relative w-full min-h-[150px] sm:min-h-[170px] md:min-h-[190px] bg-[#f6fbfd] flex items-center justify-center overflow-hidden">
          {/* Soft decorative circle */}
          <div className="absolute -top-28 -left-28 w-[360px] h-[360px] md:w-[480px] md:h-[480px] bg-blue-100 rounded-full" />

          <div className="relative z-10 w-full max-w-4xl mx-auto flex flex-col items-center justify-center text-center px-4 py-8">
            {subtitle && (
              <div className="mb-3 inline-block px-5 py-1.5 rounded-full bg-blue-100 text-blue-700 text-sm font-medium tracking-wide">
                {subtitle}
              </div>
            )}
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 leading-snug">
              {title}
            </h1>
            <div className="mt-3 h-1 w-20 bg-blue-300 rounded-full mx-auto" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
